var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slice-image-video-clip w-full"},[_c('image-video-clip',{staticClass:"w-full",attrs:{"media":_vm.slice.image && _vm.slice.image[0],"bg":false,"lazyVideo":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }